const productList_US_Locale = {
    'productList.HotlineService': 'Hotline Service',
    'productList.BusinessCooperation': 'Business Cooperation',
    'productList.FollowRayShape': 'Follow RayShape',
    'productList.OnlineConsultation':'Online consultation',
    'productList.products': 'Products',
    'productList.solutions': 'Solutions',
    'productList.AboutUs': 'About Us',
    'productList.productsItem1': 'Medical Image Annotation Software',
    'productList.productsItem2': 'Al For Fetal Ultrasound Scan',
    'productList.productsItem3': 'AI For Pelvic Ultrasound Scan',
    'productList.productsItem4': 'Al For Hip Joint Ultrasound Scan',
    'productList.productsItem5': 'Al For Breast Ultrasound Scan',
    'productList.productsItem6': 'Al For Thyroid Ultrasound Scan',
    'productList.productsItem7': 'Al For Cardiac Ultrasound Scan',
    'productList.productsItem8': 'Al For Follicle Ultrasound Scan',
    'productList.productsItem9': 'Intelligent Quality Control Platform',
    'productList.solutionsItem1': 'Full-Stack Intelligent Ultrasound Solutions',
    'productList.solutionsItem2': 'NiCE: AI Ultrasound Deployment Platform',
    'productList.aboutItem1': 'About RayShape',
    'productList.aboutItem2': 'Honors and Qualifications',
    'productList.aboutItem3': 'Corporate Culture',
}
export default productList_US_Locale
